import _ from "lodash";
import api from "@/api";

export default {
  namespaced: true,
  state: {
    options: []
  },
  getters: {},
  mutations: {
    SET_OPTIONS: (state, payload) => (state.options = payload)
  },
  actions: {
    getData: async ({ commit }) => {
      // eslint-disable-next-line no-useless-catch
      try {
        const response = await api.get("/providers/vendor-designer-options");
        const options = _.get(response, "data.result", []);

        commit("SET_OPTIONS", options);

        return response;
      } catch (error) {
        throw error;
      }
    }
  }
};
